export default __webpack_public_path__ + "static/Julianto Setiady-26a16476a53b6a6d44f0b03a8166dc74.webp";